import React from "react";
import { Row, Col, Card, Statistic, Spin } from "antd";
import {
  PlayCircleOutlined,
  CheckCircleOutlined,
  CommentOutlined,
  SmileOutlined,
  ReadOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

const OverviewCards = ({ overview, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!overview) return null;

  const cards = [
    {
      title: "Video Sessions",
      value: overview.videos?.totalSessions || 0,
      icon: <PlayCircleOutlined />,
      color: "#1890ff",
      suffix: overview.videos?.totalSessions > 0
        ? `${overview.videos?.completionRate?.toFixed(1)}% concluidos`
        : "",
    },
    {
      title: "Videos Concluidos",
      value: overview.videos?.completedSessions || 0,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
      suffix: `${overview.videos?.uniqueUsers || 0} usuarios`,
    },
    {
      title: "Comentarios",
      value: overview.comments?.totalComments || 0,
      icon: <CommentOutlined />,
      color: "#13c2c2",
      suffix: `${overview.comments?.uniqueCommenters || 0} usuarios`,
    },
    {
      title: "Reacoes",
      value: overview.reactions?.totalReactions || 0,
      icon: <SmileOutlined />,
      color: "#722ed1",
      suffix: `${overview.reactions?.uniqueReactors || 0} usuarios`,
    },
    {
      title: "Posts Lidos",
      value: overview.posts?.totalReads || 0,
      icon: <ReadOutlined />,
      color: "#fa8c16",
      suffix: `${overview.posts?.totalClaps || 0} claps`,
    },
    {
      title: "Badges Concluidos",
      value: overview.badges?.totalCompleted || 0,
      icon: <TrophyOutlined />,
      color: "#eb2f96",
      suffix: `${overview.badges?.completionRate?.toFixed(1)}% taxa`,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card) => (
        <Col xs={24} sm={12} md={8} lg={4} key={card.title}>
          <Card bordered={false} style={{ borderTop: `3px solid ${card.color}` }}>
            <Statistic
              title={
                <span>
                  {React.cloneElement(card.icon, {
                    style: { color: card.color, marginRight: 8 },
                  })}
                  {card.title}
                </span>
              }
              value={card.value}
              suffix={
                card.suffix && (
                  <span style={{ fontSize: 12, color: "#888" }}>
                    ({card.suffix})
                  </span>
                )
              }
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default OverviewCards;
